import { useEffect, useState } from "react";
import {
  getRolePermissions,
  replaceRolePermissions
} from "../services/accessControl.api";
import { useSelector } from "react-redux";

export default function usePermissions(roleId) {

  const [permissionMap, setPermissionMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [dirty, setDirty] = useState(false);

        
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
  useEffect(() => {
    if (!roleId) return;

    fetchPermissions();
  }, [roleId]);

  const fetchPermissions = async () => {

    try {
      setLoading(true);
      const data = await getRolePermissions(roleId,AppToken);

      const map = {};

      data.forEach(p => {
        if (!map[p.module]) {
          map[p.module] = [];
        }
        map[p.module].push(p.action);
      });

      setPermissionMap(map);
      setDirty(false);

    } catch (err) {
      console.error("Failed to load permissions:", err);
    } finally {
      setLoading(false);
    }
  };

  const togglePermission = (module, action) => {
    setPermissionMap(prev => {
      const updated = { ...prev };

      if (!updated[module]) {
        updated[module] = [];
      }

      if (updated[module].includes(action)) {
        updated[module] =
          updated[module].filter(a => a !== action);
      } else {
        updated[module].push(action);
      }

      setDirty(true);
      return updated;
    });
  };

  const savePermissions = async () => {

    const flatPermissions = [];

    Object.keys(permissionMap).forEach(module => {
      permissionMap[module].forEach(action => {
        flatPermissions.push({ module, action });
      });
    });

    await replaceRolePermissions(roleId, flatPermissions,AppToken);
    setDirty(false);
  };

  return {
    permissionMap,
    loading,
    dirty,
    togglePermission,
    savePermissions
  };
}